const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isGroundedTutorUnitId = value =>
  typeof value === 'string' && UUID.test(value.trim());

export const groundedTutorContextMessage =
  'Open a course lesson before starting the 1:1 tutor.';

export const buildTutorTokenRequest = ({
  mode = 'VOICE',
  session_id,
  teacherName,
  voice_id,
  courseId,
  unitId,
  lessonId,
  lastQuestion,
}) => ({
  mode: String(mode || 'VOICE').toUpperCase(),
  clientRequestId: session_id,
  instructor: teacherName,
  voiceId: voice_id,
  institution: 'quiklearn',
  courseId,
  unitId,
  lessonId: lessonId ?? null,
  conversationSessionId: session_id,
  lastQuestion,
});
